import { render } from "./chips.vue?vue&type=template&id=0870152c&scoped=true"
import script from "./chips.vue?vue&type=script&lang=js"
export * from "./chips.vue?vue&type=script&lang=js"

import "./chips.vue?vue&type=style&index=0&id=0870152c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2014718928/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0870152c"]])

export default __exports__